import { render, staticRenderFns } from "./PaymentFailed.vue?vue&type=template&id=0d001cff&"
import script from "./PaymentFailed.vue?vue&type=script&lang=js&"
export * from "./PaymentFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports